// ignore query refetches if user removed a metric
const ignoreRefetch = (current, prev = []) => {
  if (current.length < prev.length) {
    const prevSet = new Set(prev);
    let hasAllCurrentMetrics = true;
    current.forEach(c => {
      if (!prevSet.has(c)) {
        hasAllCurrentMetrics = false;
      }
    });

    return hasAllCurrentMetrics;
  }
  return false;
}

export default ignoreRefetch;
